import React from 'react';
import BenefitAmountAsPercentageOfTotalQE from './BenefitAmountAsPercentageOfTotalQE';
import CurrentYearQEComparisonToPreviousYear from './CurrentYearQEComparisonToPreviousYear';
import DashCard from '../components/DashCard';
import { useTranslation } from 'react-i18next';
const CurrentYearQE = _ref => {
  let {
    dashboardData
  } = _ref;
  const {
    t
  } = useTranslation();

  // This is a quick fix to pass the height and width property to the Chart component. That is the only reason this is done with JS.
  let radialChartHeight;
  let radialChartWidth;
  if (window.screen.availWidth > 1500) {
    radialChartHeight = '225px';
    radialChartWidth = '225px';
  } else if (window.screen.availWidth > 1200) {
    radialChartHeight = '150px';
    radialChartWidth = '150px';
  } else {
    radialChartHeight = '105px';
    radialChartWidth = '105px';
  }
  return /*#__PURE__*/React.createElement(DashCard, {
    title: t('chart_title_qualifying_expenditure_current_period'),
    className: "h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row mt-5 justify-content-between",
    style: {
      height: '200px',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-3",
    style: {
      top: '21px',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fs-1 fw-light text-primary mb-4",
    style: {
      fontSize: '2rem'
    }
  }, window.MARKET_CONSTANTS.CURRENCY_SYMBOL, window.MARKET_CONSTANTS.CURRENCY_FORMATTER.format(Math.round(dashboardData.total_qualifying_rnd_expenditure))), /*#__PURE__*/React.createElement(CurrentYearQEComparisonToPreviousYear, {
    dashboardData: dashboardData
  }))), /*#__PURE__*/React.createElement("style", null, "\n            .BenefitAmountAsPercentageOfTotalQE-container {\n              height: 105px;\n              width: 225px;\n            }\n\n            @media (max-width: 1500px) {\n              .BenefitAmountAsPercentageOfTotalQE-container {\n                height: 70px;\n                width: 150px;\n              }\n            }\n\n            @media (max-width: 1200px) {\n              .BenefitAmountAsPercentageOfTotalQE-container {\n                height: 49px;\n                width: 105px;\n              }\n            }\n          "), /*#__PURE__*/React.createElement("div", {
    className: "ms-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "BenefitAmountAsPercentageOfTotalQE-container"
  }, /*#__PURE__*/React.createElement(BenefitAmountAsPercentageOfTotalQE, {
    dashboardData: dashboardData,
    radialChartHeight: radialChartHeight,
    radialChartWidth: radialChartWidth
  })))));
};
export default CurrentYearQE;